const state = {
  current: 0,
  stepArray: [
    'confProjCtrAcct',
    'confProjSettleEntity',
    'confProjIncomeEntity',
    'confProjAcctPayEntity',
    'confProjAcctReceiveEntity',
    'confProjAcctCurEntity'
  ]
}

const getters = {
}

const actions = {
  // async gotoStep({
  //   commit,
  //   state
  // }, params) {
  //   debugger
  //   console.log('gotoStep', params)
  //   state.current = state.stepArray.indexOf(params.stepName)
  //   // await this.$router.push({path: ('/project/' + params.stepName), query: {projId: params.projId, menuKey: params.menuKey}})
  // }
}

const mutations = {
  updateCurrent(state, value) {
    state.current = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/components/proj/confProjectStepManage.js